// extracted by mini-css-extract-plugin
module.exports = {"section4":"Section4_section4__3ZPXl","zero":"Section4_zero__356MX","view":"Section4_view__aChn0"};